<!-- file -->
<ng-container *ngIf="!loading">
  <div class="tw-mt-[11px] tw-mb-10" *ngIf="fileType != FileType.Audio">
    {{ "messages.clickToShowFile" | translate }}
  </div>

  <div class="tw-flex-center tw-h-[200px]">
    <audio
      *ngIf="fileType == FileType.Audio"
      controls
      #fileController
      [style.width]="fileWidth"
      [class.hide-file-time]="!isShowTime"
      (play)="onPlay($event)"
    >
      <source />
    </audio>

    <a
      *ngIf="fileType == FileType.Video"
      [href]="fileSrc | safe : 'url'"
      target="_blank"
      rel="noopener noreferrer"
    >
      <video width="100%" [style.height]="'150px'" controls>
        <source [src]="fileSrc | safe : 'url'" type="video/mp4" />
        <source [src]="fileSrc | safe : 'url'" type="video/ogg" />
        Your browser does not support the video tag.
      </video>
    </a>

    <a
      *ngIf="fileType == FileType.Image"
      [href]="fileSrc | safe : 'url'"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        width="200"
        height="200"
        class="tw-my-2 tw-object-contain"
        [src]="fileSrc | safe : 'url'"
      />
    </a>

    <a
      *ngIf="fileType == FileType.Pdf"
      [href]="fileSrc | safe : 'url'"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        width="200"
        height="200"
        class="tw-my-2 tw-object-contain"
        src="/assets/media/svg/files/pdf.svg"
      />
    </a>
  </div>
</ng-container>

<ng-container *ngIf="loading">
  <div
    class="tw-h-[200px] tw-flex tw-flex-row tw-justify-center tw-items-center"
  >
    <span
      class="spinner-border spinner-border-sm tw-h-[30px] tw-w-[30px]"
      role="status"
      aria-hidden="true"
    ></span>
    <span class="sr-only">Loading...</span>
  </div>
</ng-container>
